
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Array,
      required: true
    },
    labels: {
      type: Array,
      required: true
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  computed: {
    options() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
              ticks: {
                  beginAtZero: true
              }
          }]
        }
      };
    }
  },
  watch: {
    chartData() {
      this.updateChart();
    },
    labels() {
      this.updateChart();
    }
  },
  methods: {
    updateChart() {
      this.$data._chart.destroy(); 
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            label: "data",
            backgroundColor: "#18CEB2",
            data: this.chartData
          }
        ]
      }, this.options);
    }
  }
};
